import React, {Component} from 'react'
import { connect } from 'react-redux'
import { Modal, TransitionablePortal, Form, TextArea, Confirm, Button } from 'semantic-ui-react'
import { requestAthleteInfo, resetAthleteRequest } from '../../store/actions/athleteActions'

const initialState = {
    coachFirstName: '',
    coachFirstNameChanged: false,
    coachLastName: '',
    coachLastNameChanged: false,
    coachEmail: '',
    coachEmailChanged: false,
    collegeName: '',
    collegeNameChanged: false,
    collegeWebsite: '',
    collegeWebsiteChanged: false,
    formComments: '',
    formCommentsChanged: false,
    coachPhone: '',
    coachPhoneChanged: false,
    athleteName: '',
    initialAthleteName: '',
    athleteNameChanged: false,
    changesMade: false,
    confirmOpen: false,
    athleteUrl: '',
    tryingToSend: false
}

class AthleteRequestForm extends Component {

    constructor(props) {
        super(props)

        this.state = initialState
        this.state.athleteName = this.props.athlete.firstName + ' ' + this.props.athlete.lastName
        this.state.initialAthleteName = this.props.athlete.firstName + ' ' + this.props.athlete.lastName
        this.state.athleteUrl = this.props.id
    }

    componentDidUpdate(prevProps) {

        if (prevProps.id !== this.props.id) {
            this.setState({
                athleteName: this.props.athlete.firstName + ' ' + this.props.athlete.lastName,
                initialAthleteName: this.props.athlete.firstName + ' ' + this.props.athlete.lastName,
                athleteUrl: this.props.id
            })
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()

        this.setState({

            tryingToSend: true
            
        }, () => {
            this.props.requestAthleteInfo(this.state)
        })
    }

    trackChanges = () => {

        if (this.state.coachFirstNameChanged || this.state.coachLastNameChanged || this.state.coachEmailChanged ||
            this.state.collegeNameChanged || this.state.collegeWebsiteChanged || this.state.formCommentsChanged ||
            this.state.athleteNameChanged || this.state.coachPhoneChanged) {

                this.setState({
                    changesMade: true
                })
        } else {
            this.setState({
                changesMade: false
            })
        }
    }

    
    handleChange = (e) => {

        this.setState({
            [e.target.id]: e.target.value
        })

        this.setState({
            [e.target.id]: e.target.value
        }, () => {

            switch(e.target.id) {
                case 'coachFirstName':
                    if (e.target.value !== '') {
                        this.setState({
                            coachFirstNameChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            coachFirstNameChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'coachLastName':
                    if (e.target.value !== '') {
                        this.setState({
                            coachLastNameChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            coachLastNameChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'coachEmail':
                    if (e.target.value !== '') {
                        this.setState({
                            coachEmailChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            coachEmailChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'coachPhone':
                    if (e.target.value !== '') {
                        this.setState({
                            coachPhoneChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            coachPhoneChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'collegeName':
                    if (e.target.value !== '') {
                        this.setState({
                            collegeNameChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            collegeNameChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'collegeWebsite':
                    if (e.target.value !== '') {
                        this.setState({
                            collegeWebsiteChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            collegeWebsiteChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'athleteName':
                    if (e.target.value !== this.state.initialAthleteName) {
                        this.setState({
                            athleteNameChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            athleteNameChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
                case 'formComments':
                    if (e.target.value !== '') {
                        this.setState({
                            formCommentsChanged: true
                        }, () => {
                            this.trackChanges()
                        })
                    } else {
                        this.setState({
                            formCommentsChanged: false
                        }, () => {
                            this.trackChanges()
                        })
                    }
                    break
            default:
                return
              }
        })
    }

    handleClose = () => {

        if (this.state.changesMade) {
            this.confirmOpen()
        } else {
            this.props.requestClose()
        }
    }

    handleExit = () => {

        this.setState(initialState, () => {

            this.props.resetAthleteRequest()

            this.props.requestClose()
        })
    }

    confirmOpen = () => this.setState({ confirmOpen: true })

    confirmClose = () => {
        this.setState(initialState, () => {

            this.handleClose()
        })
    }

    confirmCloseCancel = () => {
        this.setState({
            confirmOpen: false
        })
    }

    render () {

        const {infoRequestSent} = this.props

        const animation = 'scale'
        const duration = 500

        var saveButton = null
        var infoRequestStatus = null

        const formFirstName = <input placeholder='None' id='coachFirstName' value={this.state.coachFirstName} onChange={this.handleChange} />
        const formLastName = <input placeholder='None' id='coachLastName' value={this.state.coachLastName} onChange={this.handleChange} />
        const formEmail = <input placeholder='None' id='coachEmail' value={this.state.coachEmail} onChange={this.handleChange} />
        const formCollegeName = <input placeholder='None' id='collegeName' value={this.state.collegeName} onChange={this.handleChange} />
        const formCollegeWebsite = <input placeholder='None' id='collegeWebsite' value={this.state.collegeWebsite} onChange={this.handleChange} />
        const formAthleteName = <input placeholder='None' id='athleteName' value={this.state.athleteName} onChange={this.handleChange} />
        const formComments = <TextArea placeholder='Additional Comments' id='formComments' value={this.state.formComments} onChange={this.handleChange}/>
        const formPhone = <input placeholder='None' id='coachPhone' value={this.state.coachPhone} onChange={this.handleChange} />

        if (this.state.coachFirstName !== '' && this.state.coachLastName !== '' && this.state.collegeName !== '' &&
        this.state.athleteName !== '' && this.state.coachEmail !== '' && this.state.coachPhone !== '' && !this.state.tryingToSend) {

            saveButton = <Button
            floated='right'
            positive
            name="saveButton"
            content="Submit"
            labelPosition='right'
            icon='paper plane'
            onClick={this.handleSubmit}
            />
        } else {

            if (this.state.tryingToSend) {
                saveButton = <Button
                disabled
                loading
                floated='right'
                positive
                name="saveButton"
                content="Submit"
                labelPosition='right'
                icon='paper plane'
                onClick={this.handleSubmit}
                />

            } else {
                saveButton = <Button
                disabled
                floated='right'
                positive
                name="saveButton"
                content="Submit"
                labelPosition='right'
                icon='paper plane'
                onClick={this.handleSubmit}
                />
            }
        }

        if (infoRequestSent) {
            infoRequestStatus =
            <TransitionablePortal
                transition={{animation, duration}}
                open={infoRequestSent}
                onClose= {this.handleExit}
            >
                <Modal
                    onClose= {this.handleExit}
                    open={true}
                >
                    <Modal.Content>
                        <div className="AdminProfileUpdatedContainer">
                            <h3>Information Request Sent!</h3>
                            <Button
                                positive
                                name="okButton"
                                content="OK"
                                onClick= {this.handleExit} 
                            />
                        </div>
                    </Modal.Content>
                </Modal>
            </TransitionablePortal>
    }

        const athleteRequestForm =
                <div className="AdminFormContainer">
                    <Form >
                        <div className="AdminFormPersonalInfoContainer">
                            <h3>Student Athlete Information Request:</h3>
                            <Form.Field required>
                                <label>Your Email</label>
                                {formEmail}
                            </Form.Field>
                            <Form.Field required>
                                <label>Your Phone</label>
                                {formPhone}
                            </Form.Field>
                            <Form.Field required>
                                <label>University or College Name</label>
                                {formCollegeName}
                            </Form.Field>
                            <Form.Field>
                                <label>University or College Website</label>
                                {formCollegeWebsite}
                            </Form.Field>
                            <Form.Field required>
                                <label>Your First Name</label>
                                {formFirstName}
                            </Form.Field>
                            <Form.Field required>
                                <label>Your Last Name</label>
                                {formLastName}
                            </Form.Field>
                            <Form.Field required>
                                <label>Student Athlete You're Requesting</label>
                                {formAthleteName}
                            </Form.Field>
                            <Form.Field>
                                <label>Comments</label>
                                {formComments}
                            </Form.Field>
                        </div>
                        {infoRequestStatus}
                    </Form>
                </div>

        return (
            <TransitionablePortal
                        transition={{animation, duration}}
                        open={this.props.request}
                        onClose={() => this.handleClose()}
                    >
                        <Modal
                            onClose={() => this.handleClose()}
                            open={true}
                            >
                            <Modal.Content scrolling>
                                <div className="AdminTopButtonsProgressContainer">
                                    <div className="AdminTopButtonsContainer">
                                        <Button
                                            floated='left'
                                            circular
                                            icon='close'
                                            onClick={() => this.handleClose()}
                                        />
                                        {saveButton}
                                    </div>
                                </div>
                                {athleteRequestForm}
                                <Confirm
                                    open={this.state.confirmOpen}
                                    content='You have unsaved changes.  Are you sure you want to exit?'
                                    onCancel={this.confirmCloseCancel}
                                    onConfirm={this.confirmClose}
                                />
                            </Modal.Content>
                        </Modal>
                    </TransitionablePortal>
        )  
    }
}

const mapStateToProps = (state) => {

    return {
        infoRequestError: state.athlete.infoRequestError,
        infoRequestSent: state.athlete.infoRequestSent
    }
  }

const mapDispatchToProps = (dispatch) => {
    return {
        requestAthleteInfo: (requestInfo) => dispatch(requestAthleteInfo(requestInfo)),
        resetAthleteRequest: () => dispatch(resetAthleteRequest())
    }
  }

export default connect (mapStateToProps, mapDispatchToProps) (AthleteRequestForm)